import { render, staticRenderFns } from "./ResponsiveText.vue?vue&type=template&id=b81e3f46&scoped=true"
import script from "./ResponsiveText.vue?vue&type=script&lang=js"
export * from "./ResponsiveText.vue?vue&type=script&lang=js"
import style0 from "./ResponsiveText.vue?vue&type=style&index=0&id=b81e3f46&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b81e3f46",
  null
  
)

export default component.exports